import { useMemo } from "react";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import breakpoints from "@shared/theme/props/breakpoints";
import useWindowSize from "@shared/hooks/useWindowSize";
import { AccountModalProps, AccountTabType } from "./AccountModal.props";
import AccountWrapper from "../AccountWrapper/AccountWrapper.web";
import {
  AuthenticationContainer,
  AuthenticationContainerScreen,
} from "../AuthenticationContainer/AuthenticationContainer.web";

const { sm } = breakpoints;

const startingTabToScreenMap: Record<
  AccountTabType,
  AuthenticationContainerScreen
> = {
  login: AuthenticationContainerScreen.LOGIN,
  createAccount: AuthenticationContainerScreen.SIGNUP,
  passwordReset: AuthenticationContainerScreen.FORGOT_PASSWORD,
};

const AccountModal = ({
  onSuccess,
  startingTab = "login",
  isOpen,
  onClose,
}: AccountModalProps) => {
  const { width: windowWidth } = useWindowSize();
  const isLargerThanSm = useMemo(
    () => windowWidth && windowWidth > sm,
    [windowWidth]
  );

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <Modal.Body padding={{ base: "lg", sm: "3xl" }}>
          {!isLargerThanSm && <Modal.CloseButton color="font.dark" />}
          <AccountWrapper>
            <AuthenticationContainer
              onSuccess={onSuccess}
              startingScreen={startingTabToScreenMap[startingTab]}
            />
          </AccountWrapper>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AccountModal;
